import React from "react";

export const Javascript = () => {
  return (
    <div>
      <svg
        className="w-full h-full"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 48 48"
      >
        <path fill="#ffd600" d="M6 42V6h36v36H6z" />
        <path
          fill="#000001"
          d="M29.538 32.947c.692 1.124 1.444 2.201 3.037 2.201 1.338 0 2.04-.665 2.04-1.585 0-1.101-.726-1.492-2.198-2.133l-.807-.344c-2.329-.988-3.878-2.226-3.878-4.841 0-2.41 1.845-4.244 4.728-4.244 2.053 0 3.528.711 4.592 2.573l-2.514 1.607c-.553-.988-1.151-1.377-2.078-1.377-.946 0-1.545.597-1.545 1.377 0 .964.6 1.354 1.985 1.951l.807.344C36.452 29.645 38 30.839 38 33.523 38 36.415 35.716 38 32.65 38c-2.999 0-4.702-1.505-5.65-3.368l2.538-1.685zm-11.586.082c.506.906 1.275 1.603 2.381 1.603 1.058 0 1.667-.418 1.667-2.043V22h3.333v11.101c0 3.367-1.953 4.899-4.805 4.899-2.577 0-4.437-1.746-5.195-3.368l2.619-1.603z"
        />
      </svg>
    </div>
  );
};

export const Css = () => {
  return (
    <div>
      <svg
        className="w-full h-full"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 48 48"
      >
        <path fill="#0277BD" d="M41 5H7l3 34 14 4 14-4 3-34z" />
        <path fill="#039BE5" d="M24 8v31.9l11.2-3.2L37.7 8z" />
        <path
          fill="#FFF"
          d="M33.1 13H24v4h4.9l-.3 4H24v4h4.4l-.3 4.5-4.1 1.4v4.2l7.9-2.6.7-11.5z"
        />
        <path
          fill="#EEE"
          d="M24 13v4h-8.9l-.3-4H24zm-4.6 8l.2 4H24v-4h-4.6zm.4 6h-4l.3 5.5 7.9 2.6v-4.2l-4.1-1.4-.1-2.5z"
        />
      </svg>
    </div>
  );
};

export const Html = () => {
  return (
    <div>
      <svg
        className="w-full h-full"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 48 48"
      >
        <path fill="#E65100" d="M41 5H7l3 34 14 4 14-4 3-34z" />
        <path fill="#FF6D00" d="M24 8v31.9l11.2-3.2L37.7 8z" />
        <path
          fill="#FFF"
          d="M24 25v-4h8.6l-.7 11.5-7.9 2.6v-4.2l4.1-1.4.3-4.5H24zm8.9-8l.3-4H24v4h8.9z"
        />
        <path
          fill="#EEE"
          d="M24 30.9v4.2l-7.9-2.6-.4-5.5h4l.2 2.5 4.1 1.4zM19.1 17H24v-4h-9.1l.7 12H24v-4h-4.6l-.3-4z"
        />
      </svg>
    </div>
  );
};

export const ReactIcon = () => {
  return (
    <div>
      <svg
        className="w-full h-full"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 48 48"
      >
        <path
          fill="#80deea"
          d="M24 34C11.1 34 1 29.6 1 24s10.1-10 23-10 23 4.4 23 10-10.1 10-23 10zm0-18c-12.6 0-21 4.1-21 8 0 3.9 8.4 8 21 8s21-4.1 21-8c0-3.9-8.4-8-21-8z"
        />
        <path
          fill="#80deea"
          d="M15.1 44.6c-1 0-1.8-.2-2.6-.7-4.9-2.8-3.6-13.7 2.8-24.9 3-5.2 6.7-9.6 10.3-12.4 3.9-3 7.4-3.9 9.8-2.5 2.5 1.4 3.4 4.9 2.8 9.8-.6 4.6-2.6 10-5.6 15.2-3 5.2-6.7 9.6-10.3 12.4-2.6 2-5.1 3.1-7.2 3.1zM32.9 5.4c-1.6 0-3.7.9-6 2.7C23.5 10.8 20 15 17.1 20c-6.3 10.9-6.9 20.3-3.6 22.2 1.7 1 4.5.1 7.6-2.3C24.5 37.2 28 33 30.9 28c2.9-5 4.8-10.1 5.4-14.4.5-4-.1-6.8-1.8-7.8-.5-.2-1-.4-1.6-.4z"
        />
        <path
          fill="#80deea"
          d="M33 44.6c-5 0-12.2-6.1-17.6-15.6C8.9 17.8 7.6 6.9 12.5 4.1 17.4 1.3 26.2 7.8 32.7 19c3 5.2 5 10.6 5.6 15.2.7 4.9-.3 8.3-2.8 9.8-.8.4-1.6.6-2.5.6zM13.5 5.8c-3.3 1.9-2.7 11.3 3.6 22.2 6.3 10.9 14.1 16.1 17.4 14.2 1.7-1 2.3-3.8 1.8-7.8-.6-4.3-2.5-9.4-5.4-14.4C24.6 9.1 16.8 3.9 13.5 5.8z"
        />
        <circle cx="24" cy="24" r="4" fill="#80deea" />
      </svg>
    </div>
  );
};

export const MongoDb = () => {
  return (
    <div>
      <svg
        className="w-full h-full"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 48 48"
      >
        <path
          fill="#5d4037"
          d="M42 17.3C42 37.8 24 44 24 44S6 37.8 6 17.3c0-2.5.2-4.6.4-6.3.3-2.5 2-4.5 4.4-5.1C13.9 5 18.8 4 24 4s10.1 1 13.3 1.9c2.4.6 4.1 2.7 4.4 5.1.1 1.7.3 3.9.3 6.3z"
        />
        <path
          fill="#4caf50"
          d="M24 7c4.9 0 9.5 1 12.5 1.8 1.2.3 2 1.3 2.2 2.6.2 1.9.3 3.9.3 5.9 0 15.6-11.5 21.9-15 23.4-3.5-1.6-15-7.9-15-23.4 0-2 .1-4 .3-5.9.1-1.3 1-2.3 2.2-2.6C14.5 8 19.1 7 24 7m0-3c-5.2 0-10.1 1-13.3 1.9-2.3.6-4.1 2.7-4.3 5.1-.2 1.7-.4 3.9-.4 6.3C6 37.8 24 44 24 44s18-6.2 18-26.7c0-2.5-.2-4.6-.4-6.3-.3-2.5-2-4.5-4.4-5.1C34.1 5 29.2 4 24 4z"
        />
        <path fill="#dcedc8" d="M23 28h2v8h-2z" />
        <path
          fill="#4caf50"
          d="M24 10s-6 5-6 13c0 5.2 3.3 8.5 5 10l1-3 1 3c1.7-1.5 5-4.8 5-10 0-8-6-13-6-13z"
        />
        <path fill="#81c784" d="M24 10s-6 5-6 13c0 5.2 3.3 8.5 5 10l1-3V10z" />
      </svg>
    </div>
  );
};

export const Redux = () => {
  return (
    <div>
      <svg
        className="w-full h-full"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 48 48"
      >
        <path
          fill="#7e57c2"
          d="M23 4c-6.617 0-12 7.27-12 16.205 0 4.834 1.582 9.169 4.078 12.136A2.986 2.986 0 0015 33a3 3 0 103-3 2.96 2.96 0 00-.897.152C15.206 27.731 14 24.175 14 20.205 14 12.924 18.037 7 23 7c3.837 0 7.111 3.547 8.404 8.518 1.122.346 2.237.782 3.33 1.308C33.579 9.508 28.759 4 23 4z"
        />
        <path
          fill="#7e57c2"
          d="M35.507 20.084c-3.947-2.392-8.374-3.442-12.182-2.959A2.982 2.982 0 0021 16a3 3 0 100 6 2.995 2.995 0 002.789-1.912c3.118-.379 6.812.531 10.163 2.563 6.403 3.881 9.67 10.569 7.282 14.911-.827 1.504-2.286 2.572-4.218 3.09-2.286.611-5.007.394-7.727-.528a24.508 24.508 0 01-2.725 2.168c2.552 1.117 5.196 1.704 7.669 1.704 1.24 0 2.438-.147 3.559-.447 2.741-.733 4.841-2.304 6.071-4.542 3.153-5.731-.596-14.22-8.356-18.923z"
        />
        <path
          fill="#7e57c2"
          d="M35 28.992C35 27.34 33.657 26 32 26s-3 1.34-3 2.992c0 .669.228 1.281.6 1.779-1.279 2.802-3.744 5.567-7.062 7.578-3.865 2.344-8.185 3.202-11.555 2.302-1.932-.518-3.391-1.586-4.218-3.09-1.702-3.094-.521-7.376 2.61-10.988a22.94 22.94 0 01-.706-3.575c-5.07 4.797-7.109 11.323-4.532 16.009 1.23 2.238 3.33 3.809 6.071 4.542 1.121.3 2.318.447 3.559.447 3.346 0 7.007-1.068 10.326-3.08 3.836-2.325 6.683-5.577 8.209-8.962C33.815 31.801 35 30.541 35 28.992z"
        />
      </svg>
    </div>
  );
};

export const NodeJs = () => {
  return (
    <div>
      <svg
        className="w-full h-full"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 48 48"
      >
        <path
          fill="#388e3c"
          d="M17.204 19.122l-4.907 2.715a.563.563 0 00-.297.492v5.433c0 .203.113.39.297.492l4.908 2.717c.183.101.41.101.593 0l4.907-2.717a.566.566 0 00.295-.492v-5.433a.564.564 0 00-.297-.492l-4.906-2.715a.613.613 0 00-.594 0m25.248 4.891l-.818.452a.093.093 0 00-.049.082v.906c0 .034.019.065.049.082l.818.453a.102.102 0 00.099 0l.818-.453a.095.095 0 00.049-.082v-.906a.094.094 0 00-.05-.082l-.818-.452c-.015-.009-.032-.013-.049-.013s-.034.004-.049.013"
        />
        <path
          fill="#388e3c"
          d="M35.751 13.364l-2.389-1.333a.243.243 0 00-.361.212L33 20.295l-2.203-1.219a.613.613 0 00-.594 0h.001l-4.907 2.715a.563.563 0 00-.297.491v5.433c0 .203.113.39.297.492l4.908 2.717c.183.101.41.101.593 0l4.907-2.717a.565.565 0 00.295-.492V13.788a.487.487 0 00-.249-.424zm-2.885 13.094l-2.23 1.235a.28.28 0 01-.269 0l-2.231-1.235a.255.255 0 01-.136-.224v-2.47c0-.092.051-.177.135-.224l2.231-1.234h-.001a.29.29 0 01.27 0l2.23 1.234a.259.259 0 01.135.225v2.47a.257.257 0 01-.134.223z"
        />
        <path
          fill="#FFFAFA"
          d="M17.204 19.122L12 27.762c0 .203.113.39.297.492l4.908 2.717c.183.101.41.101.593 0L23 22.329a.564.564 0 00-.297-.492l-4.906-2.715a.613.613 0 00-.594 0"
        />
        <path
          fill="#4caf50"
          d="M17.204 19.122l-4.907 2.715a.563.563 0 00-.297.492l5.204 8.642c.183.101.41.101.593 0l4.907-2.717a.565.565 0 00.296-.492l-5.203-8.64a.613.613 0 00-.594 0"
        />
        <path
          fill="#FFFAFA"
          d="M47.703 21.791l-4.906-2.715a.613.613 0 00-.594 0h.001l-4.907 2.715a.574.574 0 00-.297.503v5.411c0 .209.114.402.297.503l4.908 2.717a.613.613 0 00.593 0l2.263-1.253a.3.3 0 00-.002-.526l-4.924-2.687a.263.263 0 01-.135-.228v-2.466c0-.092.05-.177.13-.221l2.235-1.236h-.001a.29.29 0 01.27 0l2.235 1.237c.08.044.13.129.13.221v2.012a.241.241 0 00.363.208l2.398-1.393a.483.483 0 00.24-.417v-1.88a.576.576 0 00-.297-.505zm-37 0l-4.906-2.715a.613.613 0 00-.594 0h.001L.297 21.791a.574.574 0 00-.297.503v7.465a.241.241 0 00.363.208l2.398-1.393A.482.482 0 003 28.157v-4.393c0-.092.05-.177.13-.221l2.235-1.236a.29.29 0 01.27 0l2.235 1.237c.08.044.13.129.13.221v4.393a.48.48 0 00.24.417l2.398 1.393a.246.246 0 00.242.001.245.245 0 00.12-.21v-7.464a.576.576 0 00-.297-.504z"
        />
      </svg>
    </div>
  );
};

export const Git = () => {
  return (
    <div>
      <svg
        className="w-full h-full"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 48 48"
      >
        <path
          fill="#F4511E"
          d="M42.2 22.1L25.9 5.8c-.5-.5-1.2-.8-1.9-.8s-1.4.3-1.9.8l-3.5 3.5 4.1 4.1c.4-.2.8-.3 1.3-.3 1.7 0 3 1.3 3 3 0 .5-.1.9-.3 1.3l4 4c.4-.2.8-.3 1.3-.3 1.7 0 3 1.3 3 3s-1.3 3-3 3-3-1.3-3-3c0-.5.1-.9.3-1.3l-4-4c-.1 0-.2.1-.3.1v10.4c1.2.4 2 1.5 2 2.8 0 1.7-1.3 3-3 3s-3-1.3-3-3c0-1.3.8-2.4 2-2.8V18.8c-1.2-.4-2-1.5-2-2.8 0-.5.1-.9.3-1.3l-4.1-4.1L5.8 22.1c-.5.5-.8 1.2-.8 1.9s.3 1.4.8 1.9l16.3 16.3c.5.5 1.2.8 1.9.8s1.4-.3 1.9-.8l16.3-16.3c.5-.5.8-1.2.8-1.9s-.3-1.4-.8-1.9z"
        />
      </svg>
    </div>
  );
};

export const TailWind = () => {
  return (
    <div>
      <svg 
      className="w-full h-full lg:py-3 py-2"
      preserveAspectRatio="xMidYMid" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 153.6"><linearGradient id="a" x1="-2.778%" y1="32%" y2="67.556%"><stop offset="0" stop-color="#2298bd"/><stop offset="1" stop-color="#0ed7b5"/></linearGradient><path d="M128 0C93.867 0 72.533 17.067 64 51.2 76.8 34.133 91.733 27.733 108.8 32c9.737 2.434 16.697 9.499 24.401 17.318C145.751 62.057 160.275 76.8 192 76.8c34.133 0 55.467-17.067 64-51.2-12.8 17.067-27.733 23.467-44.8 19.2-9.737-2.434-16.697-9.499-24.401-17.318C174.249 14.743 159.725 0 128 0zM64 76.8C29.867 76.8 8.533 93.867 0 128c12.8-17.067 27.733-23.467 44.8-19.2 9.737 2.434 16.697 9.499 24.401 17.318C81.751 138.857 96.275 153.6 128 153.6c34.133 0 55.467-17.067 64-51.2-12.8 17.067-27.733 23.467-44.8 19.2-9.737-2.434-16.697-9.499-24.401-17.318C110.249 91.543 95.725 76.8 64 76.8z" fill="url(#a)"/></svg>
    </div>
  );
};

export const RubyOnRails = () => {
  return (
    <div>
      <svg 
      className="w-full h-full lg:p-2 p-1"
      viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><circle cx="256" cy="256" fill="#C00" r="256"/><g fill="#FFF"><path d="M130.627 403.045h156.2s-34.6-78.7-25.8-150.9 65.8-105.1 98.1-108.6 49.9 16.4 49.9 16.4l7-10.6s-46.4-47-105.1-41.7c-58.7 5.3-99.2 44-124.5 91-25.2 47-39.9 79.9-49.9 129.2-10 49.4-5.9 75.2-5.9 75.2zM99.527 324.345l30.5 2.3-5.3 30.5-28.8-3.5 3.6-29.3zM147.627 259.745l8.2-22.9-27-10.6-8.8 24.7 27.6 8.8zM185.827 181.145l15.9-18.8-20.5-13.5-16.5 18.2 21.1 14.1zM227.527 108.345l14.1 17 19.4-11.2-14.1-15.9-19.4 10.1zM296.227 88.945l3.5 17 24.1-.6-2.4-15.3-25.2-1.1z"/><path d="M377.827 107.145l-.6 10.6 16.4 8.8 3.5-5.3-19.3-14.1zM374.327 152.345v8.8l15.9 1.8v-7l-15.9-3.6zM323.827 159.945l7.6 14.1 11.2-8.8-2.3-9.4-16.5 4.1zM299.727 178.145l11.7 17.6-7 12.3-17-18.8 12.3-11.1zM276.227 226.945l-7.6 15.3 20 17 4.7-19.4-17.1-12.9zM268.027 280.345l-1.2 20.5 24.7 10.6-1.2-19.4-22.3-11.7zM275.127 353.145l5.9 21.1 31.1 1.8-11.2-22.9h-25.8z"/></g></svg>
    </div>
  );
};

export const PostgreSQL = () => {
  return (
    <div>
      <svg 
      className="w-full h-full"
      viewBox="0 0 25.6 25.6" xmlns="http://www.w3.org/2000/svg"><g fill="none" stroke="#fff"><path d="M18.983 18.636c.163-1.357.114-1.555 1.124-1.336l.257.023c.777.035 1.793-.125 2.4-.402 1.285-.596 2.047-1.592.78-1.33-2.89.596-3.1-.383-3.1-.383 3.053-4.53 4.33-10.28 3.227-11.687-3.004-3.84-8.205-2.024-8.292-1.976l-.028.005c-.57-.12-1.2-.19-1.93-.2-1.308-.02-2.3.343-3.054.914 0 0-9.277-3.822-8.846 4.807.092 1.836 2.63 13.9 5.66 10.25C8.29 15.987 9.36 14.86 9.36 14.86c.53.353 1.167.533 1.834.468l.052-.044a2.01 2.01 0 00.021.518c-.78.872-.55 1.025-2.11 1.346-1.578.325-.65.904-.046 1.056.734.184 2.432.444 3.58-1.162l-.046.183c.306.245.285 1.76.33 2.842s.116 2.093.337 2.688.48 2.13 2.53 1.7c1.713-.367 3.023-.896 3.143-5.81" fill="#000" stroke="#000" stroke-width="2.149"/><path d="M23.535 15.6c-2.89.596-3.1-.383-3.1-.383 3.053-4.53 4.33-10.28 3.228-11.687-3.004-3.84-8.205-2.023-8.292-1.976l-.028.005a10.31 10.31 0 00-1.929-.201c-1.308-.02-2.3.343-3.054.914 0 0-9.278-3.822-8.846 4.807.092 1.836 2.63 13.9 5.66 10.25C8.29 15.987 9.36 14.86 9.36 14.86c.53.353 1.167.533 1.834.468l.052-.044a2.02 2.02 0 00.021.518c-.78.872-.55 1.025-2.11 1.346-1.578.325-.65.904-.046 1.056.734.184 2.432.444 3.58-1.162l-.046.183c.306.245.52 1.593.484 2.815s-.06 2.06.18 2.716.48 2.13 2.53 1.7c1.713-.367 2.6-1.32 2.725-2.906.088-1.128.286-.962.3-1.97l.16-.478c.183-1.53.03-2.023 1.085-1.793l.257.023c.777.035 1.794-.125 2.39-.402 1.285-.596 2.047-1.592.78-1.33z" fill="#336791" stroke="none"/><g stroke-width=".716"><g stroke-linecap="round"><path d="M12.814 16.467c-.08 2.846.02 5.712.298 6.4s.875 2.05 2.926 1.612c1.713-.367 2.337-1.078 2.607-2.647l.633-5.017M10.356 2.2S1.072-1.596 1.504 7.033c.092 1.836 2.63 13.9 5.66 10.25C8.27 15.95 9.27 14.907 9.27 14.907m6.1-13.4c-.32.1 5.164-2.005 8.282 1.978 1.1 1.407-.175 7.157-3.228 11.687" stroke-linejoin="round"/><path d="M20.425 15.17s.2.98 3.1.382c1.267-.262.504.734-.78 1.33-1.054.49-3.418.615-3.457-.06-.1-1.745 1.244-1.215 1.147-1.652-.088-.394-.69-.78-1.086-1.744-.347-.84-4.76-7.29 1.224-6.333.22-.045-1.56-5.7-7.16-5.782S7.99 8.196 7.99 8.196" stroke-linejoin="bevel"/></g><g stroke-linejoin="round"><path d="M11.247 15.768c-.78.872-.55 1.025-2.11 1.346-1.578.325-.65.904-.046 1.056.734.184 2.432.444 3.58-1.163.35-.49-.002-1.27-.482-1.468-.232-.096-.542-.216-.94.23z"/><path d="M11.196 15.753c-.08-.513.168-1.122.433-1.836.398-1.07 1.316-2.14.582-5.537-.547-2.53-4.22-.527-4.22-.184s.166 1.74-.06 3.365c-.297 2.122 1.35 3.916 3.246 3.733" stroke-linecap="round"/></g></g><g fill="#fff"><path d="M10.322 8.145c-.017.117.215.43.516.472s.558-.202.575-.32-.215-.246-.516-.288-.56.02-.575.136z" stroke-width=".239"/><path d="M19.486 7.906c.016.117-.215.43-.516.472s-.56-.202-.575-.32.215-.246.516-.288.56.02.575.136z" stroke-width=".119"/></g><path d="M20.562 7.095c.05.92-.198 1.545-.23 2.524-.046 1.422.678 3.05-.413 4.68" stroke-linecap="round" stroke-linejoin="round" stroke-width=".716"/></g></svg>
    </div>
  );
};




export const Projects = () => {
  return (
    <div>
      <svg
        className="w-full h-full p-1"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
        />
      </svg>
    </div>
  );
};

export const AboutMe = () => {
  return (
    <div>
      <svg
        className="w-full h-full p-1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"
        fill="currentColor"
      >
        <path
          fill-rule="evenodd"
          d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z"
          clip-rule="evenodd"
        />
      </svg>
    </div>
  );
};

export const Skills = () => {
  return (
    <div>
      <svg
        className="w-full h-full p-1"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4"
        />
      </svg>
    </div>
  );
};

export default Javascript;
